import { render, staticRenderFns } from "./SuperPassGames.vue?vue&type=template&id=72ef49ec&"
import script from "./SuperPassGames.vue?vue&type=script&lang=js&"
export * from "./SuperPassGames.vue?vue&type=script&lang=js&"
import style0 from "./SuperPassGames.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports